'use client';

import { toast } from 'sonner';
import Image from 'next/image';
import Link from 'next/link';

export const BadgeToast = ({ image, title, description, profileLink = '#' }) => {
  return (
    <div className="flex items-start gap-3 p-4 bg-base-100 rounded-box shadow-lg border border-base-300 max-w-md">
      <div className="avatar">
        <div className="w-12 h-12 rounded-full overflow-hidden">
          <Image
            src={image}
            alt={title}
            width={48}
            height={48}
            className="object-cover"
          />
        </div>
      </div>
      <div className="flex-1">
        <Link href={profileLink} className="hover:opacity-80 transition-opacity">
          <h3 className="font-bold text-primary">{title}</h3>
        </Link>
        <p className="text-sm text-base-content/80">{description}</p>
      </div>
      <button 
        onClick={() => toast.dismiss()}
        className="btn btn-ghost btn-sm btn-circle"
        aria-label="Close"
      >
        ✕
      </button>
    </div>
  );
};

// Helper function to show the badge toast
export const showBadgeToast = ({ image, title, description, profileLink }) => {
  toast.custom((t) => (
    <div className={`transition-all duration-300 ${
      t.visible ? 'opacity-100' : 'opacity-0'
    }`}>
      <BadgeToast 
        image={image}
        title={title}
        description={description}
        profileLink={profileLink}
      />
    </div>
  ), {
    duration: 5000,
    position: 'top-right'
  });
};